import { render, staticRenderFns } from "./EmployeeCharities.vue?vue&type=template&id=5328b9f6&scoped=true"
import script from "./EmployeeCharities.vue?vue&type=script&lang=js"
export * from "./EmployeeCharities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328b9f6",
  null
  
)

export default component.exports